import React, { useEffect, useContext } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
  Navigate,
  useOutletContext,
} from 'react-router-dom'
import LoginScreen from '../pages/Login/Login'
import PrivateRoute from './PrivateRouter'
import TenantGuard from '../components/TenantGuard'
import AdminGuard from '../components/AdminGuard'
import Validation from '../pages/Login/Validation'
import CompleteRegister from '../pages/Login/CompleteRegister'
import SuccessMsg from '../pages/Login/SuccessMsg'
import AdminRegister from '../pages/Login/AdminRegister'
import ClientPanel from '../pages/ClientPanel'
import HomeScreen from '../pages/ClientPanel/Home'
import AuditDashboard from '../pages/ClientPanel/Audit'
import CertificatesContent from '../pages/ClientPanel/Certificates'
import StockContent, { StockResourceLayout } from '../pages/ClientPanel/Stock'
import ProductionFlow from '../pages/ClientPanel/ProductionFlow'
import PeopleContent from '../pages/ClientPanel/Accesses'
import PeopleTableSwitch from '../pages/ClientPanel/Accesses/PeopleTableSwitch'

import ServicesTable from '../pages/ClientPanel/ProductionFlow/ServicesTable'
import PCPGrid from '../pages/ClientPanel/ProductionFlow/PCPGrid'
import StagesTable from '../pages/ClientPanel/ProductionFlow/StagesTable'
import CreateOPModal from '../components/Services/CreateServiceModal'
import AddOpInPcp from '../components/ModalWithoutColumns'
import StockTable from '../pages/ClientPanel/Stock/StockTable'
import MovementTable from '../pages/ClientPanel/Stock/MovementsTable'
import TableAccesses from '../pages/ClientPanel/Accesses/AccessesTable'
import TableProfile from '../pages/ClientPanel/Accesses/ProfilesTable'
import NewProfilesTable from '../pages/ClientPanel/Accesses/NewProfilesTable'
import CompaniesContent from '../pages/ClientPanel/Companies'
import CreditAnalysis from '../pages/ClientPanel/CreditAnalysis'
import AttachmentsPage from '../pages/ClientPanel/Attachments'
import NotFoundPage from '../pages/SystemErrors/NotFound'
import CertificatesTable from '../pages/ClientPanel/Certificates/CertificateTable'
import CreateCertificate from '../pages/ClientPanel/Certificates/CreateCertificate'
import ParamTable from '../pages/ClientPanel/Certificates/ParamTable'
import CreateParam from '../pages/ClientPanel/Certificates/CreateParam'
import ViewCertificateModal from '../components/Certificates/ViewCertificateModal'
import MachinesTable from '../pages/ClientPanel/ProductionFlow/MachinesTable'
import EquipmentContent from '../pages/ClientPanel/Equipment'
import EquipmentTable from '../pages/ClientPanel/Equipment/Machines/EquipmentTable'
import RegisterEquipment from '../pages/ClientPanel/Equipment/Machines/RegisterEquipment'
import EditEquipment from '../pages/ClientPanel/Equipment/Machines/EditEquipment'
import VehicleTable from '../pages/ClientPanel/Equipment/Vehicles/VehicleTable'
import ViewOPCard from '../components/Modals/ViewPCP'
import RouterTable from '../pages/ClientPanel/router/routerTable'
import RouterSection from '../pages/ClientPanel/router'
import RouterContent from '../pages/ClientPanel/router/index2'
import FreightTable from '../pages/ClientPanel/router/freightTable'
import DateAndTimeTable from '../pages/ClientPanel/router/dateAndTimeTable'
import NewRouter from '../pages/ClientPanel/router/newRouter'
import FreightContent from '../components/routerModal/freightContent'
import VehicleContent from '../components/routerModal/vehicleContent'
import VehicleForm from '../components/routerModal/vehicleContent/vehicleForm'
import VehicleDetail from '../components/routerModal/vehicleContent/vehicleDetail'
import FreightForm from '../components/routerModal/freightContent/freightForm'
import FreightDetail from '../components/routerModal/freightContent/freightDetail'
import RouterDetail from '../components/routerModal/routerContent/routerDetail'
import FashionContent from '../pages/ClientPanel/FashionOrders'
import FashionOrdersTable from '../pages/ClientPanel/FashionOrders/FashionOrdersTable'
import AddFashionOrder from '../pages/ClientPanel/FashionOrders/RegisterFashionOrder'
import PreProgramming from '../pages/ClientPanel/FashionOrders/PreProgramming'
import ProductionFashionContent from '../pages/ClientPanel/ProductionFashion'
import ProductionFashionTable from '../pages/ClientPanel/ProductionFashion/ProductionTable'
import FashionProductionMovementTable from '../pages/ClientPanel/ProductionFashion/MovementTable'
import PCPDashboard from '../pages/ClientPanel/ProductionFashion/PCPDashboard'
import AddFashionOP from '../pages/ClientPanel/ProductionFashion/AddFashionOP'
import CreateOPFashion from '../pages/ClientPanel/ProductionFashion/CreateOP'
import ServicesContent from '../pages/ClientPanel/Services'
import ResourcesContent from '../pages/ClientPanel/Resources'
import CreateResourceModal from '../components/Modals/Resource/CreateResource'
import StageServicesTable from '../pages/ClientPanel/Services/ServicesTable'
import ResourcesTable from '../pages/ClientPanel/Resources/ResourcesTable'
import CreateServiceModal from '../components/Modals/ServiceStage/CreateServiceModal'
import ViewServiceStageModal from '../components/Modals/ServiceStage/ViewServiceStageModal'
import ViewResourceModal from '../components/Modals/Resource/ViewResource'
import AddCompanyModal from '../components/AddCompanyModal'
import TableCompanies from '../pages/ClientPanel/Companies/CompaniesTable'
import ProductFinal from '../pages/ClientPanel/ProductFinal'
import AddProductFinal from '../pages/ClientPanel/ProductFinal/AddProduct'
import ProductFinalTable from '../pages/ClientPanel/ProductFinal/ProductTable'
import ViewProductFinal from '../pages/ClientPanel/ProductFinal/ViewProduct'
import ProductFinals, { ProductFinalFunnel } from '../pages/ClientPanel/ProductFinal'
import SteelOrders from '../pages/ClientPanel/SteelOrders'
import AddOrder from '../pages/ClientPanel/SteelOrders/AddOrder'
import SteelOrdersTable from '../pages/ClientPanel/SteelOrders/SteelOrdersTable'
import ViewSteelOrder from '../pages/ClientPanel/SteelOrders/ViewSteelOrder'
import Tracking from '../pages/ClientPanel/SteelOrders/ViewSteelOrder/TrackingOrderTable/tracking'
import Orders from '../pages/ClientPanel/Orders'
import { TableFiltersProvider } from '../contexts/TableFiltersContext'
import PipelineContent from '../pages/ClientPanel/Pipelines'
import Kanban from '../pages/ClientPanel/Pipelines/kanban'
import ViewOrEditTicket from '../components/Pipelines/Modals/ViewOrEditTicket'
import StepHistoryReport from '../pages/ClientPanel/Pipelines/StepHistoryReport'
import ServicesTable2 from '../pages/ClientPanel/ProductionFlow/ServicesTable/index2'
import CreateOP from '../pages/ClientPanel/ProductionFlow/CreateOP'
import MagicLogin from '../pages/Login/MagicLogin/index'
import DocsIndex from '../pages/Docs'
import DocViewer from '../pages/Docs/DocViewer'
import UserContext from '../contexts/UserContext'
import GenerateInspectionFormModal from '../components/Modals/ViewPCP/GenerateInspectionForm'
import CollectionsContent from '../pages/ClientPanel/Collections'
import CollectionsTable from '../pages/ClientPanel/Collections/CollectionsTable'
import RegisterCollection from '../pages/ClientPanel/Collections/RegisterCollection'
import ProductCompositionContent from '../pages/ClientPanel/ProductComposition'
import CompositionTable from '../pages/ClientPanel/ProductComposition/CompositionTable'
import RegisterComposition from '../pages/ClientPanel/ProductComposition/RegisterComposition'
import RncTable from '../pages/ClientPanel/Certificates/RncTable'
import PurchaseContent from '../pages/ClientPanel/Purchase'
import PurchaseDemandTable from '../pages/ClientPanel/Purchase/PurchaseDemandTable'
import PurchaseOrderTable from '../pages/ClientPanel/Purchase/PurchaseOrderTable'
import FinancialEntriesContent from '../pages/ClientPanel/FinancialEntries'
import FinancialEntriesTable from '../pages/ClientPanel/FinancialEntries/FinancialEntriesTable'
import FinancialEntryForm from '../pages/ClientPanel/FinancialEntries/FinancialEntryForm'
import DreLinesContent from '../pages/ClientPanel/DreLines'
import DreLinesTable from '../pages/ClientPanel/DreLines/DreLinesTable'
import ProductDevelopmentContent, { ProductDevelopmentFunnel } from '../pages/ClientPanel/ProductDevelopment'
import { useTenant } from '../contexts/TenantContext'
import TaxModuleLayout from '../pages/ClientPanel/TaxModule'
import InvoiceTable from '../pages/ClientPanel/TaxModule/Invoice/InvoiceTable'
import InvoiceForm from '../pages/ClientPanel/TaxModule/Invoice/InvoiceForm'
import ViewInvoice from '../pages/ClientPanel/TaxModule/Invoice/ViewInvoice'
import ScenarioTable from '../pages/ClientPanel/TaxModule/TaxScenario/TaxScenarioTable'
import CreateTaxScenario from '../pages/ClientPanel/TaxModule/TaxScenario/CreateScenario'
import NcmRules from '../pages/ClientPanel/TaxModule/TaxScenario/NcmRules'
import FiscalSettings from '../pages/ClientPanel/TaxModule/Settings'
import { SearchProvider } from '../contexts/SearchContext'

const ClientPanelLayout = () => (
  <PrivateRoute>
    <TableFiltersProvider>
      <SearchProvider>
        <ClientPanel />
      </SearchProvider>
    </TableFiltersProvider>
  </PrivateRoute>
)


const TenantTrackingGuard = () => {
  const { user } = useContext(UserContext);
  const { tenantId } = useTenant();
  const location = useLocation();
  const context = useOutletContext();

  const isTenantClient = (user?.role as string) === 'TENANT_CLIENT';
  const isAcoTenant = tenantId !== 2;

  console.log('🧭 [TENANT-TRACKING-GUARD] Snapshot', {
    pathname: location.pathname,
    userRole: user?.role,
    userId: user?.id || user?.sub,
    tenantId,
    isTenantClient,
    isAcoTenant,
    willRedirectToTracking: isTenantClient && isAcoTenant && location.pathname === '/panel',
  })

  if (isTenantClient && isAcoTenant && location.pathname === '/panel') {
    console.warn('🧭 [TENANT-TRACKING-GUARD] Redirecionando para /panel/steel/tracking', {
      pathname: location.pathname,
      tenantId,
      userRole: user?.role,
    })
    return <Navigate to="/panel/steel/tracking" replace />;
  }

  return <Outlet context={context} />;
};

const Router = () => {
  return (
    <BrowserRouter basename='/'>
      <Routes>
        {/** Rotas Públicas */}
        <Route path='/' element={<LoginScreen />} />
        <Route path='/login' element={<LoginScreen />} />
        <Route path='/magic-login' element={<MagicLogin />} />
        <Route path='/accessvalidation' element={<Validation />} />
        <Route path='/pendingmessage' element={<SuccessMsg />} />
        <Route path='/completeRegister' element={<CompleteRegister />} />
        <Route path='/internalaccess/:token' element={<AdminRegister />} />

        {/** Rotas Privadas dentro do ClientPanel */}
        <Route path='*' element={<NotFoundPage />} />
        <Route path='/panel' element={<ClientPanelLayout />}>
          <Route path='*' element={<NotFoundPage />} />

          <Route element={<TenantTrackingGuard />}>
            <Route index element={<HomeScreen />} />
            <Route path='certificates' element={<CertificatesContent />}>
              <Route index element={<CertificatesTable />} />
              <Route path='view/:id' element={<ViewCertificateModal />} />
              <Route path='create' element={<CreateCertificate />} />
              <Route path='edit' element={<CreateCertificate />} />
              <Route path='params' element={<ParamTable />} />
              <Route path='params/create' element={<CreateParam />} />
              <Route path='params/edit' element={<CreateParam />} />
              <Route path='rnc' element={<RncTable />} />
            </Route>
            <Route path='stock' element={<StockContent />}>
              <Route index element={<StockTable />} />
              <Route path='movement' element={<MovementTable />} />
              <Route path='resource' element={<StockResourceLayout />}>
                <Route index element={<ResourcesTable />} />
                <Route path='create' element={<CreateResourceModal />} />
                <Route path='edit' element={<CreateResourceModal />} />
                <Route path='view' element={<ViewResourceModal />} />
              </Route>
              <Route path='sales' element={<Outlet />} />
            </Route>
            <Route path='product-final' element={<ProductFinals />}>
              <Route index element={<ProductFinalTable />} />
              <Route path='funnel' element={<ProductFinalFunnel />} />
              <Route path=':productId' element={<ViewProductFinal />} />
              <Route path='create' element={<AddProductFinal />} />
              <Route path='edit/:productId' element={<AddProductFinal />} />
            </Route>
            <Route path='production' element={<ProductionFlow />}>
              <Route index element={<ServicesTable2 />} />
              <Route path='movement' element={<FashionProductionMovementTable />} />
              <Route path='board' element={<Outlet />} />
              <Route path='2' element={<ServicesTable />} />
              <Route path='create' element={<CreateOP />} />
              <Route path='edit/:id' element={<CreateOP />} />
              <Route path='2/card' element={<ViewOPCard />} />
              <Route path='services/card' element={<ViewOPCard />} />
              <Route path='pcp/:stageId' element={<AddOpInPcp />} />
              <Route path='services/create' element={<CreateOPModal />} />
              <Route path='stages' element={<StagesTable />} />

            </Route>
            <Route path='purchase' element={<PurchaseContent />}>
              <Route index element={<Navigate to='demand' replace />} />
              <Route path='demand' element={<PurchaseDemandTable />} />
              <Route path='orders' element={<PurchaseOrderTable />} />
            </Route>
            <Route
              path='fashion'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <FashionContent />
                </TenantGuard>
              }
            >
              <Route index element={<FashionOrdersTable />} />

              <Route path='board' element={<Outlet />} />
              <Route path='create' element={<AddFashionOrder />} />
              <Route path='edit/:orderId' element={<AddFashionOrder />} />
            </Route>
            <Route
              path='production-fashion'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <ProductionFashionContent />
                </TenantGuard>
              }
            >
              <Route index element={<ProductionFashionTable />} />
              <Route path='movement' element={<FashionProductionMovementTable />} />
              <Route path='pcp' element={<PCPDashboard />}>
                <Route path='create' element={<AddFashionOP />} />
              </Route>
              <Route path='create' element={<CreateOPFashion />} />
              <Route path='board' element={<Outlet />} />
            </Route>
            <Route path='people' element={<PeopleContent />}>
              <Route index element={<PeopleTableSwitch />} />
              <Route path='profiles' element={<TableProfile />} />
              <Route path='profiles-v2' element={<NewProfilesTable />} />
            </Route>
            <Route
              path='steel'
              element={
                <TenantGuard requiredTenant='Aco'>
                  <SteelOrders />
                </TenantGuard>
              }
            >
              <Route index element={<SteelOrdersTable />} />
              <Route path='tracking' element={<Tracking />} />
              <Route path='board' element={<Outlet />} />
              <Route path=':orderId' element={<ViewSteelOrder />} />
              <Route path='create' element={<AddOrder />} />
              <Route path='edit/:orderId' element={<AddOrder />} />
            </Route>
            <Route path='companies' element={<CompaniesContent />}>
              <Route path='create' element={<AddCompanyModal />} />
              <Route path='edit' element={<AddCompanyModal />} />
            </Route>
            <Route path='attachments' element={<AttachmentsPage />} />
            <Route path='analise-credito' element={<CreditAnalysis />} />
            <Route path='service' element={<ServicesContent />}>
              <Route index element={<StageServicesTable />} />
              <Route path='create' element={<CreateServiceModal />} />
              <Route path='edit' element={<CreateServiceModal />} />
              <Route path='view' element={<ViewServiceStageModal />} />
            </Route>
            <Route path='resource' element={<ResourcesContent />}>
              <Route index element={<ResourcesTable />} />
              <Route path='create' element={<CreateResourceModal />} />
              <Route path='edit' element={<CreateResourceModal />} />
              <Route path='view' element={<ViewResourceModal />} />
            </Route>
            <Route path='mach' element={<MachinesTable />} />
            <Route
              path='router'
              element={
                <TenantGuard requiredTenant={['Aco', 'fashion']}>
                  <RouterContent />
                </TenantGuard>
              }
            >
              <Route index element={<FreightTable />} />
              <Route path='create' element={<FreightForm />} />
              <Route path=':freightId' element={<FreightDetail />} />
              <Route path='routers' element={<RouterTable />} />
              <Route path='dateAndTime' element={<DateAndTimeTable />} />
              <Route path='routers/create' element={<NewRouter />} />
              <Route path='routers/:routerId' element={<RouterDetail />} />
              <Route path='routers/edit' element={<NewRouter />} />
            </Route>
            <Route path='equipment' element={<EquipmentContent />}>
              <Route index element={<EquipmentTable />} />
              <Route path='register' element={<RegisterEquipment />} />
              <Route path='edit/:id' element={<EditEquipment />} />
              <Route path='vehicles' element={<VehicleTable />} />
            </Route>
            <Route
              path='product-development'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <Navigate to='/panel/collection' replace />
                </TenantGuard>
              }
            />
            <Route
              element={
                <TenantGuard requiredTenant='fashion'>
                  <ProductDevelopmentContent />
                </TenantGuard>
              }
            >
              <Route path='collection' element={<CollectionsContent />}>
                <Route index element={<CollectionsTable />} />
                <Route path='register' element={<RegisterCollection />} />
                <Route path='edit/:id' element={<RegisterCollection />} />
              </Route>
              <Route path='collection/funnel' element={<ProductDevelopmentFunnel />} />
              <Route path='composition-product' element={<ProductCompositionContent />}>
                <Route index element={<CompositionTable />} />
                <Route path='create' element={<RegisterComposition />} />
                <Route path='edit/:productId' element={<RegisterComposition />} />
              </Route>
            </Route>
            <Route path='orders' element={<Orders />} />
            <Route path='pipeline' element={<PipelineContent />}>
              <Route index element={<Kanban />} />
              <Route path='ticket' element={<ViewOrEditTicket />} />
              <Route path='reports' element={<StepHistoryReport />} />
            </Route>
            <Route path='financial' element={<Outlet />}>
              <Route index element={<Navigate to='entry' replace />} />
              <Route path='entry' element={<FinancialEntriesContent />}>
                <Route index element={<FinancialEntriesTable />} />
                <Route path='new' element={<FinancialEntryForm />} />
                <Route path=':id/edit' element={<FinancialEntryForm />} />
              </Route>
              <Route path='dre-line' element={<DreLinesContent />}>
                <Route index element={<DreLinesTable />} />
              </Route>
            </Route>
            <Route path='invoice' element={<TaxModuleLayout />}>
              <Route index element={<InvoiceTable />} />
              <Route path='create' element={<InvoiceForm />} />
              <Route path='edit/:id' element={<InvoiceForm />} />
              <Route path='view/:id' element={<ViewInvoice />} />
              <Route path='tax-scenario' element={<ScenarioTable />} />
              <Route path='tax-scenario/create' element={<CreateTaxScenario />} />
              <Route path='tax-scenario/ncm-rules' element={<NcmRules />} />
              <Route path='settings' element={<FiscalSettings />} />
            </Route>
            <Route path='docs' element={
              <AdminGuard>
                <DocsIndex />
              </AdminGuard>
            } />
            <Route path='docs/:docId' element={
              <AdminGuard>
                <DocViewer />
              </AdminGuard>
            } />
            <Route path='audit' element={
              <AdminGuard>
                <AuditDashboard />
              </AdminGuard>
            } />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
